// Lib
import { albumsTabs } from '@/lib/albums/tabs';

// Components
import TabsLink from '@/components/composite/TabsLink';
import AlbumsCreateButton from '@/components/pages/albums/AlbumsCreateButton';

// Types
import type { AlbumsCreateButtonProps } from '@/components/pages/albums/AlbumsCreateButton';

type AlbumsHeaderProps = { toggleAlbumFunnel: AlbumsCreateButtonProps['onClick'] };

const AlbumsHeader = ({ toggleAlbumFunnel }: AlbumsHeaderProps) => {
    return (
        <header className="z-10 mb-5 flex flex-wrap items-center justify-between gap-4 pb-5 pt-10">
            <TabsLink tabsList={albumsTabs} />
            <AlbumsCreateButton onClick={toggleAlbumFunnel} />
        </header>
    );
};

export default AlbumsHeader;
